import { Carousel } from 'react-responsive-carousel'

const SLIDES = [
  {
    text: `“I have to admit I was a bit skeptical as I have seen other sites promising an easy transaction. I was very happy with how my purchase went. The person that handled my transaction on the phone kept me well informed, made me feel at ease and answered all my questions. When I got my car it was exactly as it was described. Extremely satisfied.”`,
    author: 'Brad T.',
    status: 'Verified user since 2021',
  },
  {
    text: `“I wanted to sell my car myself to get all of the money, but I was hesitant because I have heard so many horror stories. The listing process takes about 15 minutes which isn’t bad as it saves you time down the road from answering questions. I received 2 offers within a week and took the second one that was within $300 of my asking price. The site handled all of the details, came and got my old car and paid me the same day. I would use this site again.”`,
    author: 'Darryl A.',
    status: 'Verified user since 2022',
  },
  {
    text: `“Once I found the car I wanted (2019 Mustang GT) Michael from the customer service department took care of my credit app, got me approved and then arranged the delivery. I opted to have them wash it inside and out which cost a bit more but was worth it to have it delivered clean. I passed on the warranty but liked the fact it was offered.”`,
    author: 'Mona D.',
    status: 'Verified user since 2021',
  },
  {
    text: `“Its very easy to communicate while remaining anonymous. I didn’t want people knowing where I lived or coming to my house. This is a much better way to sell a car online than a classified site. The concierge team handled everything on the phone and it was a fairly fast process getting paid.”`,
    author: 'Edward C.',
    status: 'Verified user since 2022',
  },
  {
    text: `“I put my truck up for auction but it didn’t get the money I wanted for it. I then opted for them to make me an offer and it was better than I thought it would be. I’m sure if I wanted to spend the time I could have gotten more but they came and got the truck and paid me within the same week so I was happy with it”`,
    author: 'Dawn S.',
    status: 'Verified user since 2022',
  },
  {
    text: `“Pretty easy way to see what you can get for your vehicle rather than trusting average prices found online. The mobile app is handy…much easier than uploading pictures from a file.”`,
    author: 'Sam S.',
    status: 'Verified user since 2022',
  },
]

// ----------------------------------------------------------------------

const indicatorStyles = {
  background: 'var(--common-white)',
  width: 14,
  height: 14,
  display: 'inline-block',
  margin: '0 1.3rem',
  borderRadius: '50%',
  opacity: 0.37,
  cursor: 'pointer',
}

const renderIndicator = (onClickHandler, isSelected, index, label) => {
  if (isSelected) {
    return (
      <li
        style={{ ...indicatorStyles, opacity: 1 }}
        aria-label={`Selected: ${label} ${index + 1}`}
        title={`Selected: ${label} ${index + 1}`}
      />
    )
  }
  return (
    <li
      style={indicatorStyles}
      onClick={onClickHandler}
      onKeyDown={onClickHandler}
      value={index}
      key={index}
      role='button'
      tabIndex={0}
      title={`${label} ${index + 1}`}
      aria-label={`${label} ${index + 1}`}
    />
  )
}

const CarouselItem = ({ text, author, status }) => {
  return (
    <div className='root'>
      <p className='text'>{text}</p>
      <p className='author'>{author}</p>
      <p className='status'>{status}</p>

      <style jsx>{`
        .root {
          display: flex;
          flex-direction: column;
          align-items: center;
          color: var(--primary-text-color);
          padding: 0 0 5.2rem;
          cursor: grab;

          .text {
            max-width: 90rem;
            margin: 4rem 0 2rem;
            line-height: 3.6rem;
            text-align: center;
            font-size: 2rem;
          }

          .author {
            line-height: 3.2rem;
            font-size: 1.8rem;
            font-weight: 700;
          }

          .status {
            color: #a5a8b9;
            font-size: 1.6rem;
          }
        }

        @media (max-width: 1024px) {
          .root {
            padding: 0 1.2rem 4rem;

            .text {
              max-width: 60rem;
              margin: 3rem 0 2.5rem;
              line-height: 1.8rem;
              font-size: 1.4rem;
            }

            .author {
              line-height: 1.8rem;
              font-size: 1.4rem;
            }

            .status {
              font-size: 1.4rem;
            }
          }
        }
      `}</style>
    </div>
  )
}

// ----------------------------------------------------------------------

export default function CarouselSection() {
  return (
    <div className='container'>
      <h3>What people are saying</h3>
      <Carousel
        autoPlay
        infiniteLoop
        showArrows={false}
        showStatus={false}
        renderIndicator={renderIndicator}
        showThumbs={false}
        interval={15000}
        emulateTouch={true}
      >
        {SLIDES.map((slide, index) => (
          <CarouselItem key={index} {...slide} />
        ))}
      </Carousel>

      <style jsx>{`
        .container {
          padding: 4.2rem 0 2rem;
          background: var(--secondary-bg-color);
          overflow: hidden;

          h3 {
            text-align: center;
            font-size: 3.2rem;
          }
        }

        @media (max-width: 1024px) {
          .container {
            h3 {
              font-size: 2rem;
            }
          }
        }
      `}</style>
    </div>
  )
}
